import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetUserQuery } from '@services/authApi';
import { UserState } from '@features/Auth/user.slice';
import { useSelector } from 'react-redux';
import { RootState } from '@redux/store';

const ProtectedRoute = () => {
  const user = useGetUserQuery();
  const userState: UserState = useSelector((state: RootState) => state.user);

  if (userState?.user?.signedIn || user?.data?.signedIn) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
